"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkLuhn = checkLuhn;
exports.getCardMatches = getCardMatches;
exports.getMaskedCardString = getMaskedCardString;
exports.getMaskedSsnString = getMaskedSsnString;
exports.getSsnMatches = getSsnMatches;
/*
 * Copyright 2018 Expedia, Inc. All rights reserved.
 * EXPEDIA PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

function getPartialUnmaskedCardString(cardString) {
  return cardString.substring(cardString.length - 4);
}
function getPartialMaskedCardString(cardString) {
  var digitPattern = /\d/g;
  return cardString.substring(0, cardString.length - 4).replace(digitPattern, '*');
}
function getCleanupCardString(cardString) {
  var delimiterPattern = /[\s-.]/g;
  return cardString.replace(delimiterPattern, '');
}
function removeDuplicates(match, index, matches) {
  if (index === 0) {
    return true;
  }
  return match !== matches[0];
}
function getCardMatches(message) {
  // We want a matching group for the first possible valid CC string, from 13 digits on.
  // This fails if its two back-to-back CC numbers, but the previous iteration did too...
  var cardPattern = /\b(?:[a-zA-Z]*)((?:\d[ -.]*?){13,16})\b/g;
  var matches = [];
  var match;
  // eslint-disable-next-line no-cond-assign
  while ((match = cardPattern.exec(message)) !== null) {
    match[0] = match[0].trim();
    matches.push(match.filter(removeDuplicates));
  }
  return matches.length ? matches : null;
}
function getSsnMatches(message) {
  var reversedMessage = message.split('').reverse().join('');
  var forwardSsnPattern = /(?!666|000|9\d{2})\d{3}[- ]{0,1}(?!00)\d{2}[- ]{0,1}(?!0{4})\d{4}(?!\d)/g;
  var reverseSssnPattern = /(?:\d{9}|\d{4}-\d{2}-\d{3})(?!\d)/g;
  var matches = [];
  var forwardMatch;
  var reverseMatch;

  // eslint-disable-next-line no-cond-assign
  while ((forwardMatch = forwardSsnPattern.exec(message)) !== null) {
    var reverseIndex = message.length - forwardMatch.index - forwardMatch[0].length;
    reverseMatch = reversedMessage.substring(reverseIndex).match(reverseSssnPattern);
    if (reverseMatch !== null && forwardMatch[0] === reverseMatch[0].split('').reverse().join('')) {
      forwardMatch[0] = forwardMatch[0].trim();
      matches.push(forwardMatch.filter(removeDuplicates));
    }
  }
  return matches.length ? matches : null;
}
function checkLuhn(cardString) {
  var cardNumber = getCleanupCardString(cardString);
  var cardNumberSize = cardNumber.length;
  var digitNine = 9;
  var sum = 0;
  var alternate = false;
  for (var index = cardNumberSize - 1; index >= 0; index -= 1) {
    var digit = parseInt(cardNumber.charAt(index), 10);
    if (alternate) {
      digit *= 2;
      digit = digit > digitNine ? digit % 10 + 1 : digit;
    }
    sum += digit;
    alternate = !alternate;
  }
  return sum % 10 === 0;
}
function getMaskedCardString(cardString) {
  var maskedCardString = getPartialMaskedCardString(cardString);
  var unmaskedCardString = getPartialUnmaskedCardString(cardString);
  return maskedCardString.concat(unmaskedCardString);
}
function getMaskedSsnString(ssnString) {
  ssnString.replace(/-/g, '');
  var maskedCardString = getPartialMaskedCardString(ssnString);
  var unmaskedCardString = getPartialUnmaskedCardString(ssnString);
  return maskedCardString.concat(unmaskedCardString).replace(/(\*{3})(\*{2})(\d{4})/, '$1-$2-$3');
}